import React, { useCallback, useState } from 'react'
import { Button, Box, Typography } from '@material-ui/core'
import { CloseIcon } from '~/assets/icons'
import { Installment, TablePager } from '~/components'
import { InstallmentsTable } from '..'

export type InstallmentsModalProps = {
  toggleModal: () => void,
  installments: Installment[]
}

export const InstallmentsModal: React.FC<InstallmentsModalProps> = (props) => {
  const { toggleModal, installments } = props
  const [page, setPage] = useState(1)
  const onPageChange = useCallback((_, page: number) => {
    setPage(page)
  }, [])

  return (
    <Box sx={{
      padding: '64px 16px'
    }}>
      <Button
        color='secondary'
        onClick={() => toggleModal()}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'textGray2.main'
        }}
      >
        <CloseIcon />
      </Button>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        alignItems: 'center'
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Typography variant='airbnbH3' sx={{ fontSize: '22px' }}>
            Fluxo previsto de pagamento
          </Typography>
          <Typography sx={{ marginTop: 2, marginBottom: 2 }} variant='airbnbBody1'>
            Veja abaixo a previsão do fluxo de pagamento das parcelas do seu empréstimo:
          </Typography>
          <InstallmentsTable noBorder numberOfInstallments={installments.length} installments={installments.slice((page - 1) * 10, page * 10)} />
        </Box>
        <TablePager page={page} onPageChange={onPageChange} pageCount={Math.ceil(installments.length / 10)} />
      </Box>
    </Box>
  )
}
